(function () {
  var root = document.getElementById('plist');
  if (!root) return;
  var grid = document.getElementById('plist-grid');
  var items = Array.prototype.slice.call(grid.querySelectorAll('.plist__item'));
  var pagination = document.getElementById('plist-pagination');
  var empty = document.getElementById('plist-empty');
  var counts = root.querySelectorAll('[data-plist-count]');
  var sortButtons = root.querySelectorAll('.plist__sort');
  var mq = window.matchMedia('(min-width: 750px)');

  var state = { kinds: [], sizes: [], recycled: false, price: 'all', sort: 'reco', page: 1 };

  // URLパラメータから復元（共有・戻る対応）
  var params = new URLSearchParams(location.search);
  if (params.get('kind')) state.kinds = params.get('kind').split(',');
  if (params.get('size')) state.sizes = params.get('size').split(',');
  if (params.get('recycled') === '1') state.recycled = true;
  if (params.get('price')) state.price = params.get('price');
  if (params.get('sort')) state.sort = params.get('sort');
  if (params.get('page')) state.page = parseInt(params.get('page'), 10) || 1;

  root.querySelectorAll('input[name="kind"]').forEach(function (i) { i.checked = state.kinds.indexOf(i.value) >= 0; });
  root.querySelectorAll('input[name="size"]').forEach(function (i) { i.checked = state.sizes.indexOf(i.value) >= 0; });
  var rc = root.querySelector('input[name="recycled"]'); if (rc) rc.checked = state.recycled;
  root.querySelectorAll('input[name="price"]').forEach(function (i) { i.checked = i.value === state.price; });

  function perPage() {
    return parseInt(mq.matches ? root.dataset.perPagePc : root.dataset.perPageSp, 10) || 9;
  }

  function matches(el) {
    var price = parseInt(el.dataset.price, 10) / 100;
    var kind = el.dataset.kind || '';
    var sizes = (el.dataset.size || '').split(' ').filter(Boolean);
    if (state.kinds.length && state.kinds.indexOf(kind) < 0) return false;
    if (state.sizes.length && !sizes.some(function (s) { return state.sizes.indexOf(s) >= 0; })) return false;
    if (state.recycled && el.dataset.recycled !== 'true') return false;
    if (state.price === 'lo' && !(price < 3000)) return false;
    if (state.price === 'mid' && !(price >= 3000 && price < 5000)) return false;
    if (state.price === 'hi' && !(price >= 5000)) return false;
    return true;
  }

  function syncUrl() {
    var p = new URLSearchParams();
    if (state.kinds.length) p.set('kind', state.kinds.join(','));
    if (state.sizes.length) p.set('size', state.sizes.join(','));
    if (state.recycled) p.set('recycled', '1');
    if (state.price !== 'all') p.set('price', state.price);
    if (state.sort !== 'reco') p.set('sort', state.sort);
    if (state.page > 1) p.set('page', String(state.page));
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  function render() {
    var list = items.filter(matches);
    if (state.sort === 'lohi') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
    else if (state.sort === 'hilo') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
    else list.sort(function (a, b) { return a.dataset.index - b.dataset.index; });

    var per = perPage();
    var pages = Math.max(1, Math.ceil(list.length / per));
    if (state.page > pages) state.page = pages;
    if (state.page < 1) state.page = 1;
    var start = (state.page - 1) * per;
    var visible = list.slice(start, start + per);

    items.forEach(function (el) { el.hidden = true; });
    visible.forEach(function (el, i) { el.hidden = false; el.style.order = i; });
    grid.hidden = list.length === 0;
    empty.hidden = list.length !== 0;
    counts.forEach(function (c) { c.textContent = list.length; });
    sortButtons.forEach(function (b) { b.classList.toggle('is-active', b.dataset.sort === state.sort); });

    pagination.innerHTML = '';
    if (pages > 1) {
      var mk = function (label, target, active, disabled) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = label; b.className = 'plist__page' + (active ? ' is-active' : '');
        b.disabled = !!disabled;
        if (active) b.setAttribute('aria-current', 'page');
        b.addEventListener('click', function () { state.page = target; render(); syncUrl(); scrollTop(); });
        return b;
      };
      pagination.appendChild(mk('‹', state.page - 1, false, state.page === 1));
      // ページ数が多い場合は 1 … p-1 p p+1 … N に間引く（SPで横に溢れないように）
      var nums = [];
      if (pages <= 7) { for (var i = 1; i <= pages; i++) nums.push(i); }
      else {
        nums.push(1);
        var lo = Math.max(2, state.page - 1), hi = Math.min(pages - 1, state.page + 1);
        if (state.page <= 3) { lo = 2; hi = 4; }
        if (state.page >= pages - 2) { lo = pages - 3; hi = pages - 1; }
        if (lo > 2) nums.push('…');
        for (var j = lo; j <= hi; j++) nums.push(j);
        if (hi < pages - 1) nums.push('…');
        nums.push(pages);
      }
      nums.forEach(function (n) {
        if (n === '…') { var s = document.createElement('span'); s.className = 'plist__page-gap'; s.textContent = '…'; pagination.appendChild(s); }
        else pagination.appendChild(mk(String(n), n, n === state.page));
      });
      pagination.appendChild(mk('›', state.page + 1, false, state.page === pages));
    }
  }

  function scrollTop() {
    var y = root.querySelector('.plist__bar').getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.name === 'kind') state.kinds = Array.prototype.map.call(root.querySelectorAll('input[name="kind"]:checked'), function (i) { return i.value; });
    else if (t.name === 'size') state.sizes = Array.prototype.map.call(root.querySelectorAll('input[name="size"]:checked'), function (i) { return i.value; });
    else if (t.name === 'recycled') state.recycled = t.checked;
    else if (t.name === 'price') state.price = t.value;
    else return;
    state.page = 1;
    render(); syncUrl();
  });

  sortButtons.forEach(function (b) {
    b.addEventListener('click', function () { state.sort = b.dataset.sort; state.page = 1; render(); syncUrl(); });
  });

  // SPの絞り込みパネル開閉（+ / −）。details/summary は iOS Safari で開閉が効かない環境があったため button で制御
  var spToggle = document.getElementById('plist-filters-sp');
  if (spToggle) {
    spToggle.addEventListener('click', function () {
      var open = !root.classList.contains('is-filter-open');
      root.classList.toggle('is-filter-open', open);
      spToggle.setAttribute('aria-expanded', String(open));
      var mark = spToggle.querySelector('.plist__filter-toggle-mark');
      if (mark) mark.textContent = open ? '−' : '+';
    });
  }

  mq.addEventListener('change', function () { state.page = 1; render(); });
  render();

  // Liquidのpaginate上限（50件）を超える分は ?view=plist&page=N で取得してグリッドに追記する
  var totalPages = parseInt(grid.dataset.pages, 10) || 1;
  if (totalPages > 1) {
    var base = location.pathname + '?view=' + (grid.dataset.view || 'plist') + '&page=';
    var fetchPage = function (n) {
      if (n > totalPages) return;
      fetch(base + n).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var added = Array.prototype.slice.call(tmp.querySelectorAll('.plist__item'));
        added.forEach(function (el) { grid.appendChild(el); });
        items = items.concat(added);
        render();
        fetchPage(n + 1);
      }).catch(function () {});
    };
    fetchPage(2);
  }
})();
